module.exports = __webpack_public_path__ + "./assets/img_kao_grey@2x__21fb8a657d20a84c92010ed7bd82ad39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kao_grey@2x.jpg
// module id = 624
// module chunks = 12